const dropdown = {
    btns: document.querySelectorAll('.jsDropdownTrigger'),
    dropdowns: document.querySelectorAll('.jsDropdown'),
    wrap: document.querySelectorAll('.jsDropdownWrap'),

    init() {
        this.setDwopdown();
        this.clickOutside();
    },

    setDwopdown() {
        this.btns.forEach((item, index) => {
            item.addEventListener('click', () => {              
                this.dropdowns[index].classList.toggle('activeClass');
            })
        });
       
    },
    clickOutside() {

        window.addEventListener('click', (e) => {
            let inside = false;
            this.wrap.forEach(item => {
                if (item.contains(e.target as HTMLElement)) {
                    inside = true               
                    return inside;                   
                }
              
            })
            if (!inside) {
                this.dropdowns.forEach(item => {
                    item.classList.remove('activeClass');
                })
               
            }

         })
    }

}

export default dropdown;